import LandingPage from "./LandingPage";
import "./App.css";

function App() {
  return <LandingPage />;
}

export default App;
